const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/accessibleride-dev/us-central1/api';

export default API_BASE_URL;
